import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';

export const useDeleteTemplateMutation = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isLoading, isError } = useMutation<
    unknown,
    Error,
    { companyId: string; templateId: string }
  >({
    mutationFn: ({ companyId, templateId }) =>
      api.delete(`admin/companies/${companyId}/templates/${templateId}`),
    onSuccess: (_data, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'companies', companyId, 'templates'] });
    },
  });

  const deleteTemplate = async (companyId: string, templateId: string) => {
    await mutateAsync({ companyId, templateId });
  };

  return {
    deleteTemplate,
    isLoading,
    isError,
  };
};
